export var ContractStateEnum;
(function (ContractStateEnum) {
    ContractStateEnum["Unspecified"] = "Unspecified";
    ContractStateEnum["Pending"] = "Pending";
    ContractStateEnum["Purchase"] = "Purchase";
    ContractStateEnum["Cancel"] = "Cancel";
    ContractStateEnum["Exercise"] = "Exercise";
    ContractStateEnum["Amend"] = "Amend";
})(ContractStateEnum || (ContractStateEnum = {}));
export var HotelCfarCancelScenarioEnum;
(function (HotelCfarCancelScenarioEnum) {
    HotelCfarCancelScenarioEnum["ContactCustomerService"] = "ContactCustomerService";
    HotelCfarCancelScenarioEnum["CancellationFailure"] = "CancellationFailure";
    HotelCfarCancelScenarioEnum["Canceled"] = "Canceled";
    HotelCfarCancelScenarioEnum["CfarRefundable"] = "CfarRefundable";
    HotelCfarCancelScenarioEnum["Pending"] = "Pending";
    HotelCfarCancelScenarioEnum["HtsCfarExercise"] = "HtsCfarExercise";
})(HotelCfarCancelScenarioEnum || (HotelCfarCancelScenarioEnum = {}));
export var CancellationFareRulesResponseEnum;
(function (CancellationFareRulesResponseEnum) {
    CancellationFareRulesResponseEnum["Failure"] = "Failure";
    CancellationFareRulesResponseEnum["Success"] = "Success";
})(CancellationFareRulesResponseEnum || (CancellationFareRulesResponseEnum = {}));
export var HotelItineraryState;
(function (HotelItineraryState) {
    HotelItineraryState["Canceled"] = "Canceled";
    HotelItineraryState["Cancelled"] = "Cancelled";
    HotelItineraryState["Past"] = "Past";
    HotelItineraryState["Future"] = "Future";
    HotelItineraryState["Invalid"] = "Invalid";
    HotelItineraryState["CancellationFailure"] = "CancellationFailure";
    HotelItineraryState["Present"] = "Present";
})(HotelItineraryState || (HotelItineraryState = {}));
//# sourceMappingURL=hotelItinerary.js.map